import React from "react";
import { FaUndo } from "react-icons/fa";

const AnalyticsFilters = ({
  filters,
  selectedReport,
  selectedPersona,
  selectedUser,
  loading,
  onReportChange,
  onPersonaChange,
  onUserChange,
  onReset,
}) => {
  return (
    <div className="flex flex-wrap items-end gap-3">
      {/* Report */}
      <div className="w-[160px]">
        <label className="text-[11px] font-medium text-gray-500 mb-1.5 block">Report</label>
        <select
          value={selectedReport}
          onChange={(e) => onReportChange(e.target.value)}
          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700 focus:border-[var(--app-button-color)] focus:outline-none focus:ring-1 focus:ring-[var(--app-button-color)]/30"
        >
          <option value="">All Reports</option>
          {filters.reports.map((r) => (
            <option key={r.id} value={r.id}>{r.name}</option>
          ))}
        </select>
      </div>
      {/* Persona */}
      <div className="w-[160px]">
        <label className="text-[11px] font-medium text-gray-500 mb-1.5 block">Persona</label>
        <select
          value={selectedPersona}
          onChange={(e) => onPersonaChange(e.target.value)}
          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700 focus:border-[var(--app-button-color)] focus:outline-none focus:ring-1 focus:ring-[var(--app-button-color)]/30"
        >
          <option value="">All Personas</option>
          {filters.personas.map((p) => (
            <option key={p.id} value={p.id}>{p.name}</option>
          ))}
        </select>
      </div>
      {/* User */}
      <div className="w-[480px]">
        <label className="text-[11px] font-medium text-gray-500 mb-1.5 block">User</label>
        <input
          type="text"
          list="analytics-users-list"
          placeholder="All Users"
          value={selectedUser}
          onChange={(e) => onUserChange(e.target.value)}
          className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs text-gray-700 placeholder-gray-400 focus:border-[var(--app-button-color)] focus:outline-none focus:ring-1 focus:ring-[var(--app-button-color)]/30"
        />
        <datalist id="analytics-users-list">
          {filters.users.map((u) => (
            <option key={u} value={u} />
          ))}
        </datalist>
      </div>
      {/* Actions */}
      <div className="flex items-center gap-2">
        <button
          onClick={onReset}
          disabled={loading}
          className="rounded-lg border border-gray-200 bg-white px-3 h-[34px] text-xs font-medium text-gray-600 hover:bg-gray-50 disabled:opacity-50"
        >
          <FaUndo size={10} />
        </button>
      </div>
    </div>
  );
};

export default AnalyticsFilters;
